import { FormInstance, Modal, ModalProps, Skeleton } from 'antd';
import { useIntl } from 'react-intl';
import PersonContactForm from './PersonContactForm';
import { LegalPersonContactFormInterface } from './types';

interface Props extends ModalProps {
  personType: 'NaturalPerson' | 'LegalPerson';
  form: FormInstance<LegalPersonContactFormInterface>;
  loading?: boolean;
  onDetailRemove(detailId: number): Promise<void>;
  onCancel: () => void;
  fieldsDisabled?: boolean;
}

export default function MultipleContactModal({
  personType,
  form,
  loading,
  onDetailRemove,
  onCancel,
  fieldsDisabled = false,
  ...props
}: Props) {
  const intl = (message: string) => useIntl().formatMessage({ id: message });

  return (
    <Modal
      destroyOnClose
      title={intl('commons.contact')}
      okText={intl('commons.modal.button.save')}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      okButtonProps={{ disabled: fieldsDisabled }}
      {...props}
    >
      <Skeleton loading={loading}>
        <PersonContactForm
          onDetailRemove={onDetailRemove}
          form={form}
          personType={personType}
          fieldsDisabled={fieldsDisabled}
        />
      </Skeleton>
    </Modal>
  );
}
